module.exports = __webpack_public_path__ + "img/bb-logo-colored.7b37b950.svg";